import { render, staticRenderFns } from "./SmsTransactionDetail.vue?vue&type=template&id=11b9152f&scoped=true"
import script from "./SmsTransactionDetail.vue?vue&type=script&lang=js"
export * from "./SmsTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./SmsTransactionDetail.vue?vue&type=style&index=0&id=11b9152f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b9152f",
  null
  
)

export default component.exports